import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  CircularProgress,
  FormHelperText,
  Checkbox,
  MenuItem,
  ListItemText,
  Chip,
  InputAdornment,
  IconButton,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";
import { Alert, Autocomplete } from "@material-ui/lab";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import { useStore } from "@store/store";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIcon from "@assets/images/checked-icon.svg";
import closeIcon from "@assets/images/close.svg";
import { allowAlphaNumeric, generatePassword } from "@utils/commonFunctions";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { AddPopupStyle } from "./style";

function Popup(props) {
  const classes = AddPopupStyle();
  const materialClasses = materialCommonStyles();
  const [state] = useStore();
  const [scroll] = useState("body");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const listOfParentCustomer = state?.common?.parentCustomers || [];

  return (
    <>
      <Dialog open={props.open} className={classes.customModal} scroll={scroll}>
        <div className="close-modal">
          <img src={closeIcon} alt="Close" onClick={props.handleClose} />
        </div>
        <form
          noValidate
          autoComplete="off"
          className={classes.customForm}
          onSubmit={props.formik.handleSubmit}
        >
          {props.error && <Alert severity="error">{props.error}</Alert>}
          <DialogTitle>
            {" "}
            {props.isEdit ? "Edit" : "Add"} Connected Customer
          </DialogTitle>
          <DialogContent>
            <div className="form-row">
              <div className="form-group">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Name</label>
                  <TextField
                    name="name"
                    id="name"
                    placeholder="Name"
                    variant="outlined"
                    type="text"
                    onChange={props.formik.handleChange}
                    onKeyPress={allowAlphaNumeric}
                    value={props.formik.values.name}
                    error={
                      props.formik.touched.name &&
                      Boolean(props.formik.errors.name)
                    }
                    helperText={
                      props.formik.touched.name && props.formik.errors.name
                    }
                  />
                </FormControl>
              </div>
              <div className="form-group">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Email</label>
                  <TextField
                    placeholder="Email address"
                    variant="outlined"
                    type="email"
                    id="email"
                    name="email"
                    onChange={props.formik.handleChange}
                    value={props.formik.values.email}
                    error={
                      props.formik.touched.email &&
                      Boolean(props.formik.errors.email)
                    }
                    helperText={
                      props.formik.touched.email && props.formik.errors.email
                    }
                  />
                </FormControl>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group password-row">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Password</label>
                  <TextField
                    id="password"
                    name="password"
                    placeholder="Password"
                    variant="outlined"
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    onChange={props.formik.handleChange}
                    value={props.formik.values.password}
                    error={
                      props.formik.touched.password &&
                      Boolean(props.formik.errors.password)
                    }
                    helperText={
                      props.formik.touched.password &&
                      props.formik.errors.password
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            right: 0,
                          }}
                        >
                          <IconButton
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
              <div className="form-group password-row">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text">Confirm Password</label>
                  <TextField
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="Confirm password"
                    variant="outlined"
                    autoComplete="off"
                    type={showConfirmPassword ? "text" : "password"}
                    onChange={props.formik.handleChange}
                    value={props.formik.values.confirmPassword}
                    error={
                      props.formik.touched.password &&
                      Boolean(props.formik.errors.confirmPassword)
                    }
                    helperText={
                      props.formik.touched.confirmPassword &&
                      props.formik.errors.confirmPassword
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            right: 0,
                          }}
                        >
                          <IconButton
                            aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group btn-auto-generate-password">
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    const newPassword = generatePassword();
                    props.formik.setFieldValue("password", newPassword);
                    props.formik.setFieldValue("confirmPassword", newPassword);
                  }}
                >
                  Auto Generate Password
                </a>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group full-width">
                <label className="label-text">Parent Customers</label>
                <FormControl
                  variant="outlined"
                  className={classes.autoComplete}
                >
                  <Autocomplete
                    multiple
                    className={materialClasses.autoComplete}
                    id="parentCustomer"
                    limitTags={2}
                    options={listOfParentCustomer}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option?.name}
                    value={props.formik.values.parentCustomer}
                    onChange={(event, newValue) => {
                      props.formik.setFieldValue("parentCustomer", newValue);
                    }}
                    renderOption={(option, { selected }) => (
                      <MenuItem
                        key={option?.id}
                        value={option?.id}
                        className={materialClasses.autoComplete}
                      >
                        <Checkbox
                          checked={selected}
                          icon={<img src={uncheckedIcon} alt="CheckBox" />}
                          checkedIcon={
                            <img src={checkedIcon} alt="CheckBox" />
                          }
                        />
                        <ListItemText primary={option?.name} />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <React.Fragment key={option.id}>
                          {index > 0 && (
                            <span key={option?.id} className="comma-separator">, </span>
                          )}
                          <Chip
                            key={option?.id}
                            label={option?.name}
                            {...getTagProps({ index })}
                          />
                        </React.Fragment>
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        variant="outlined"
                        className="label-text"
                        placeholder={
                          props.formik.values.parentCustomer.length > 0
                            ? ""
                            : "Select Parent Customer"
                        }
                      />
                    )}
                  />
                  <FormHelperText className="error-text">
                    {props.formik.touched.parentCustomer &&
                      props.formik.errors.parentCustomer}
                  </FormHelperText>
                </FormControl>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group checkbox-wrapper">
                <FormControl component="fieldset">
                  <FormGroup aria-label="position" className="custom-checkbox">
                    <FormControlLabel
                      value="end"
                      control={
                        <Checkbox
                          name="isMapCockpitAutoRefresh"
                          icon={<img src={uncheckedIcon} alt="CheckBox" />}
                          checkedIcon={<img src={checkedIcon} alt="CheckBox" />}
                          onChange={
                            () => {
                              props.formik.setFieldValue(
                                "isMapCockpitAutoRefresh",
                                props.formik.values.isMapCockpitAutoRefresh ? 0 : 1
                              );
                            }
                          }
                          checked={props.formik.values.isMapCockpitAutoRefresh}
                          value={props.formik.values.isMapCockpitAutoRefresh}
                        />
                      }
                      label="Wanted to auto refresh customer portal mapcockpit?"
                      labelPlacement="end"
                    />
                  </FormGroup>
                </FormControl>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="bottom-button-block">
            <Button
              className="primary-btn gray-border-btn"
              color="inherit"
              disableElevation
              underlinenone="true"
              onClick={props.handleClose}
            >
              Cancel
            </Button>
            <Button
              className="orange-btn primary-btn"
              color="inherit"
              disableElevation
              underlinenone="true"
              type="submit"
              disabled={
                state.connectedUser.addingUser ||
                state.connectedUser.editingUser
              }
            >
              {state.connectedUser.addingUser ||
                state.connectedUser.editingUser ? (
                <CircularProgress color="inherit" />
              ) : (
                "SAVE USER"
              )}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
export default Popup;
